//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueTelInput } from 'vue-tel-input'
import { mapGetters } from 'vuex'
import vInput from '~/mixins/vInput.js'
import 'vue-tel-input/dist/vue-tel-input.css'
import { absolutePosition } from '~/utils/v'

export default {
  name: 'Tel',
  components: { VueTelInput },
  mixins: [vInput],
  data () {
    return {
      isOpen: false,
      input: {
        destroy: false
      },
      defaultObj: null
    }
  },
  methods: {
    onCountryChange (obj) {
      this.defaultObj = obj
      this.$emit('countryChanged', obj)
      if (obj.dialCode) {
        this.$nextTick(() => {
          if (!this.input.isFocus && !this.model?.includes(obj.dialCode)) {
            this.model = `+${obj.dialCode}`
          }
        })
      }
    },
    onOpen () {
      this.isOpen = true
    },
    onClose () {
      this.isOpen = false
    },
    setAbsolute () {
      absolutePosition(this.$refs['v-tel'], this.$refs.input.$refs.list)
    },
    updateAbsolute () {
      if (this.isOpen && this.$refs.input?.$refs?.list) {
        window.addEventListener('scroll', this.setAbsolute, true)
        window.addEventListener('resize', this.setAbsolute, true)
        this.setAbsolute()
      } else {
        window.removeEventListener('scroll', this.setAbsolute)
        window.removeEventListener('resize', this.setAbsolute)
      }
    }
  },
  computed: {
    ...mapGetters({
      countryCodes: 'data/countryCodes',
      ip: 'ip'
    }),
    getSubText () {
      if (this.hasErrorText) {
        return
      }
      return this.subText
    },
    getCountryCode () {
      if (this.ip?.country_code2) {
        this.input.destroy = true
        this.$nextTick(() => {
          this.input.destroy = false
        })
        return this.ip.country_code2
      }
      return 'en'
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    isOpen () {
      if (!this.isOpen) {
        this.setHover(false)
      }
      this.$nextTick(() => {
        this.updateAbsolute()
      })
    },
    model () {
      if (!this.model.replace(' ', '').includes(this.defaultObj.dialCode)) {
        this.$nextTick(() => {
          this.model = `+${this.defaultObj.dialCode}`
        })
      }
    }
  },
  created () {
    this.$store.dispatch('getIpInfo', {})
  }
}
